module.exports = __webpack_public_path__ + "static/media/vnit_logo.c728ebd4.png";